

<!-- Banner -->
<section id="banner">
    <div class="inner">
        <h1>Multi-Cloud Total Cost of Ownership (TCO) Calculator</h1>
        <p style="color: white;">Estimate the cost savings you can realize by migrating your workloads to public clouds</p>
        <!--<ul class="actions">
            <li><a href="#" class="button alt">Get Started</a></li>
        </ul> One -->
    </div>
</section>


<!-- One -->

<form class="msform" method="post">
    <!-- progressbar -->
    <ul class="progressbar">
        <li class="active">Define Workloads</li>
        <li class="active">Adjust Assumptions</li>
        <li class="">View Report</li>
    </ul>
</form>




<section class="container">
    <div class="row mt-0">
        <div class="col-lg-10 col-md-8 col-sm-12 col-12">
            <header>
                <h2>Adjust assumptions</h2>
                <p>The following assumptions in the TCO model are industry averages accredited by Nucleus Research. To
                     get a more accurate TCO report, update and customize these values to reflect your situation,
                    which can vary by industry and location.</p>
            </header>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12 col-12">
            <label for='Currency'>Currency</label>
            <select id='Currency' [(ngModel)]="selectedCurrencyId">
                <option
                    *ngFor="let options of shareDataService.currencies"
                    [attr.key]="options.CurrencyCode"
                    [attr.value]="options.ID"
                >{{options.CurrencyDesc}}</option>
            </select>
        </div>
    </div>

    <hr />

    <div class="row mt-0" *ngIf="false">
        <div class="col-12">
            <header>
                <h2>Software Assurance coverage (provides Azure Hybrid Benefit)</h2>
                <p>Enable this if you have purchased this benefit for your on-premises Windows or SQL Servers. If
                    enabled, Azure Hybrid Benefit (AHB) will be applied to Azure estimates. AHB helps you get more value
                    from your on-premises licenses — save up to 40 percent on virtual machines and up to 82 percent with
                    Azure Reserved Virtual Machines (VM) instances.</p>
            </header>
        </div>
        <div class="col-lg-10 col-md-8 col-sm-12 col-12">
            <p>Windows Server Software Assurance coverage</p>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12 col-12"  style=" text-align: right;">
            <label class="switch">
                <input type="checkbox">
                <span class="slider round"></span>
            </label>
        </div>
        <div class="col-lg-10 col-md-8 col-sm-12 col-12">
            <p>SQL Server Software Assurance coverage</p>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12 col-12" style=" text-align: right;">
            <label class="switch">
                <input type="checkbox">
                <span class="slider round"></span>
            </label>
        </div>
        <div class="col-4">
            <p><a href="#" class="text-decoration-none"> Learn more about Software Assurance ></a></p>
        </div>
        <div class="col-4">
            <p><a href="#" class="text-decoration-none"> Learn more about Azure Hybrid Benefit ></a></p>
        </div>
    </div>

    <!-- <hr> -->

    <div class="row mt-0" *ngIf="false">
        <div class="col-lg-10 col-md-8 col-sm-12 col-12">
            <header>
                <h2>Geo-redundant storage (GRS)</h2>
                <p>GRS replicates your data to a secondary region that is hundreds of miles away form the primary
                    region.</p>
                <p><a href="#" class="text-decoration-none">Learn more about GRS ></a></p>
            </header>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12 col-12" style=" text-align: right;">
            <label class="switch">
                <input type="checkbox">
                <span class="slider round"></span>
            </label>
        </div>

    </div>

    <!-- <hr> -->

    <div class="row mt-0" *ngIf="false">
        <div class="col-lg-10 col-md-8 col-sm-12 col-12">
            <header>
                <h2>Virtual Machine costs</h2>
                <p>Enable this for the Calculator to not recommend Bs-series virtual machines</p>
                <p><a href="#" class="text-decoration-none">Learn more about Bs-series virtual machines ></a></p>
            </header>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12 col-12" style=" text-align: right;">
            <label class="switch">
                <input type="checkbox">
                <span class="slider round"></span>
            </label>
        </div>

    </div>

    <!-- <hr> -->

    <div class="row mt-5" *ngIf="false">
        <div class="col-lg-10 col-md-8 col-sm-12 col-12">
            <header>
                <h2>Electricity costs</h2>
                <p>Price per KW hour</p>
            </header>
        </div>
        <div class='input-field _input-field col-lg-2 col-md-4 col-sm-12 col-12' style=" text-align: right;">
            <input type='number' id='servers' name='servers' value='1' min='1' max='20000' [(ngModel)]="data.PricePerKWHour">>
            <!-- <p>USD</p> -->
        </div>
    </div>

    <!-- <hr> -->




    <!-- <div class="row mt-0">
        <div class="col-lg-10 col-md-8 col-sm-12 col-12">
            <header>
                <h2>IT labor costs</h2>
            </header>
        </div>
        <div class='col-12' *ngFor="let item of itlaborcosts">
            <div class="row  pl-2">
                <div class="col-lg-10 col-md-8 col-sm-12 col-12">
                    <header>
                        <p>{{item.Description}}</p>
                    </header>
                </div>
                <div class='input-field _input-field col-lg-2 col-md-4 col-sm-12 col-12'  style=" text-align: right;">
                    <input type='number' [attr.id]="item.ID" name='servers' value='1' min='1' max='20000' [(ngModel)]="item.Value">
                </div>
            </div>
        </div>
    </div> -->


    <div class="row">
        <div class="col-12">

            <div id='formId' class='mt-1'>
                <div class='row'>
                    <div style='float: left; text-align: center;' id='divf1'>
                        <div class='circle' (click)="onSTOToggleClick('Hardware')">
                            <img src='../../assets/images/arrow_down.svg' width='14px' height='14px'
                                id='Server"+index+"'/>
                        </div>
                    </div>
                    <div class='col droptitle pl-3 pr-3 ml-3 mt-0'>
                        <div class='row '>
                            <div class='col mt-1'>
                                <header>
                                    <H5>Hardware costs</H5>
                                </header>
                            </div>
                        </div>
                        <div id="Hardware" *ngIf="toggleOptions.Hardware">
                            <!-- <div id="Hardware" style="display: none;">  #needtocheck-->
                            <div class="row mt-0" *ngFor="let item of hardwareCostAssumption">
                                <div class="col-lg-10 col-md-8 col-sm-12 col-12">
                                    <header>
                                        <p>{{item.Procs}} Proc, {{item.Cores}} Core/Proc, {{item.Size}} GB RAM</p>
                                    </header>
                                </div>
                                <div class='input-field _input-field col-lg-2 col-md-4 col-sm-12 col-12' style="text-align: right;">
                                    <input type='number' id='servers' name='servers' value='1' min='1' max='20000'[(ngModel)]="item.Price">
                                    <!-- <p>USD</p> -->
                                </div>
                            </div>
                            <div class="row mt-0" *ngIf="false">
                                <div class="col-md-10">
                                    <header>
                                        <p>Hardware maintenance cost as a % of hardware cost</p>
                                    </header>
                                </div>
                                <div class='input-field _input-field col-2' style="text-align: right;">
                                    <input type='number' id='servers' name='servers' value='1' min='1' max='20000'>
                                    <!-- <p>USD</p> -->
                                </div>
                            </div>
                            <div class="row mt-0" *ngIf="false">
                                <div class="col-lg-10 col-md-8 col-sm-12 col-12">
                                    <header>
                                        <p>K80 cost</p>
                                    </header>
                                </div>
                                <div class='input-field _input-field col-lg-2 col-md-4 col-sm-12 col-12' style="text-align: right;">
                                    <input type='number' id='servers' name='servers' value='1' min='1' max='20000' [(ngModel)]="data.K80Cost">
                                    <!-- <p>USD</p> -->
                                </div>
                            </div>
                            <div class="row mt-0" *ngIf="false">
                                <div class="col-lg-10 col-md-8 col-sm-12 col-12">
                                    <header>
                                        <p>M60 cost</p>
                                    </header>
                                </div>
                                <div class='input-field _input-field col-lg-2 col-md-4 col-sm-12 col-12' style="text-align: right;">
                                    <input type='number' id='servers' name='servers' value='1' min='1' max='20000' [(ngModel)]="data.M60Cost">
                                    <!-- <p>USD</p> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id='"+formId+"' class='mt-2'>
                <div class='row'>
                    <div style='float: left; text-align: center;' id='"divf1"'>

                        <div class='circle' (click)='onSTOToggleClick("Software")'>
                            <img src='../../assets/images/arrow_down.svg' width='14px' height='14px'
                                id='Server"+index+"'/>
                        </div>

                    </div>
                    <div class='col droptitle pl-3 pr-3 ml-3 mt-0'>
                        <div class='row'>
                            <div class='col mt-1'>
                                <header>
                                    <H5>Software costs</H5>
                                </header>
                            </div>
                        </div>
                        <div id="Software" *ngIf="toggleOptions.Software">
                            <div class="row">
                                <div class="col-lg-10 col-md-8 col-sm-8 col-9">
                                    <header>
                                        <H6>On-premises Operating System License</H6>
                                    </header>
                                </div>
                                <div class="col-lg-2 col-md-4 col-sm-4 col-3">
                                    <header>
                                        <H6>Cost</H6>
                                    </header>
                                </div>
                            </div>

                            <div class="row mt-0" *ngFor="let item of SoftwareCostAssumption">
                                <div class="col-lg-10 col-md-8 col-sm-8 col-9">
                                    <header>
                                        <p>{{item.Description}}</p>
                                    </header>
                                </div>
                                <div class='input-field _input-field col-lg-2 col-md-4 col-sm-4 col-3' style="text-align: right;">
                                    <input type='number' [attr.id]="item.ID" name='servers' value='1' min='1' max='20000' [(ngModel)]="item.Value">
                                    <!-- <p>USD</p> -->
                                </div>
                            </div>
                        </div>


                    </div>



                    
                </div>
            </div>
            <div id='"+formId+"' class='mt-2'>
                <div class='row'>
                    <div style='float: left; text-align: center;' id='"divf1"'>
                        <div class='circle' (click)='onSTOToggleClick("storageTab")'>
                            <img src='../../assets/images/arrow_down.svg' width='14px' height='14px'
                                id='Server"+index+"'/>
                        </div>
                    </div>
                    <div class='col droptitle pl-3 pr-3 ml-3 mt-0'>
                        <div class='row'>
                            <div class='col mt-1'>
                                <header>
                                    <H5>Storage costs</H5>
                                </header>
                            </div>
                        </div>
                        <div id="storageTab" *ngIf="toggleOptions.storageTab">
                            <div class="row" *ngFor="let item of storageAssumption">
                                <div class="col-lg-10 col-md-8 col-sm-12 col-12">
                                    <header>
                                        <p>{{item.Description}}</p>
                                    </header>
                                </div>
                                <div class='input-field _input-field col-lg-2 col-md-4 col-sm-12 col-12' style="text-align: right;">
                                    <input type='number' [attr.id]="item.ID" name='servers' value='1' min='1' max='20000' [(ngModel)]="item.Value">
                                    <!-- <p>USD</p> -->
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div id='"+formId+"' class='mt-2'>
                <div class='row'>
                    <div style='float: left; text-align: center;' id='"divf1"'>

                        <div class='circle' (click)='onSTOToggleClick("Electricity")'>
                            <img src='../../assets/images/arrow_down.svg' width='14px' height='14px'
                                id='Server"+index+"'/>
                        </div>

                    </div>
                    <div class='col droptitle  pl-3 pr-3 ml-3 mt-0'>
                        <div class='row'>
                            <div class='col mt-1'>
                                <header>
                                    <H5>Electricity costs</H5>
                                </header>
                            </div>
                        </div>
                        <div id="Electricity" *ngIf="toggleOptions.Electricity">
                            <div class="row">
                                <div class="col-lg-10 col-md-8 col-sm-8 col-9">
                                    <header>
                                        <H6>Hardware configuration</H6>
                                    </header>
                                </div>
                                <div class="col-lg-2 col-md-4 col-sm-4 col-3">
                                    <header>
                                        <H6>Power rating (watts)</H6>
                                    </header>
                                </div>
                            </div>

                            <div class="row mt-0" *ngFor="let item of electricityCostAssumption">
                                <div class="col-lg-10 col-md-8 col-sm-8 col-9">
                                    <header>
                                        <p>{{item.Procs}} Proc, {{item.Cores}} Core/Proc, {{item.Size}} GB RAM</p>
                                    </header>
                                </div>
                                <div class='input-field _input-field col-lg-2 col-md-4 col-sm-4 col-3' style="text-align: right;">
                                    <input type='number' id='servers' name='servers' value='1' min='1' max='20000'[(ngModel)]="item.Price">
                                    <!-- <p>USD</p> -->
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div id='"+formId+"' class='mt-2'>
                <div class='row'>
                    <div style='float: left; text-align: center;' id='"divf1"'>

                        <div class='circle' (click)='onSTOToggleClick("Virtualization")'>
                            <img src='../../assets/images/arrow_down.svg' width='14px' height='14px'
                                id='Server"+index+"'/>
                        </div>

                    </div>
                    <div class='col droptitle pl-3 pr-3 ml-3 mt-0'>
                        <div class='row'>
                            <div class='col mt-1'>
                                <header>
                                    <H5>Virtualization costs</H5>
                                </header>
                            </div>
                        </div>
                        <div id="Virtualization" *ngIf="toggleOptions.Virtualization">
                            <div class="row">
                                <div class="col-lg-10 col-md-8 col-sm-12 col-12">
                                    <header>
                                        <p>Per virtual machine, per month, infrastructure cost to load balance, backup
                                            and patch virtual machines</p>
                                    </header>
                                </div>
                                <div class='input-field _input-field col-lg-2 col-md-4 col-sm-12 col-12' style="text-align: right;">
                                    <input type='number' id='servers' name='servers' value='1' min='1' max='20000'>
                                    <!-- <p>USD</p> -->
                                </div>
                            </div>
                            <div class="row mt-0">
                                <div class="col-lg-10 col-md-8 col-sm-12 col-12">
                                    <header>
                                        <p>Virtual Machine density (Number of vCPUs per physical core) </p>
                                    </header>
                                </div>
                                <div class='input-field _input-field col-lg-2 col-md-4 col-sm-12 col-12' style="text-align: right;">
                                    <input type='number' id='servers' name='servers' value='1' min='1' max='20000'>
                                    <!-- <p>USD</p> -->
                                </div>
                            </div>
                            <div class="row mt-0">
                                <div class="col-lg-10 col-md-8 col-sm-12 col-12">
                                    <header>
                                        <p>Average utilisation (%)</p>
                                    </header>
                                </div>
                                <div class='input-field _input-field col-lg-2 col-md-4 col-sm-12 col-12' style="text-align: right;">
                                    <input type='number' id='servers' name='servers' value='1' min='1' max='20000'>
                                    <!-- <p>USD</p> -->
                                </div>
                            </div>
                            <div class="row mt-0">
                                <div class="col-lg-10 col-md-8 col-sm-12 col-12">
                                    <header>
                                        <p>VMware Virtualization software licence cost per physical proc</p>
                                    </header>
                                </div>
                                <div class='input-field _input-field col-lg-2 col-md-4 col-sm-12 col-12' style="text-align: right;">
                                    <input type='number' id='servers' name='servers' value='1' min='1' max='20000'>
                                    <!-- <p>USD</p> -->
                                </div>
                            </div>
                            <div class="row mt-0">
                                <div class="col-lg-10 col-md-8 col-sm-12 col-12">
                                    <header>
                                        <p>Hyper-V Virtualization software licence cost</p>
                                    </header>
                                </div>
                                <div class='input-field _input-field col-lg-2 col-md-4 col-sm-12 col-12' style="text-align: right;">
                                    <input type='number' id='servers' name='servers' value='1' min='1' max='20000'>
                                    <!-- <p>USD</p> -->
                                </div>
                            </div>


                        </div>

                    </div>
                </div>
            </div>

            <div id='"+formId+"' class='mt-2'>
                <div class='row'>
                    <div style='float: left; text-align: center;' id='"divf1"'>

                        <div class='circle' (click)='onSTOToggleClick("Data")'>
                            <img src='../../assets/images/arrow_down.svg' width='14px' height='14px'
                                id='Server"+index+"'/>
                        </div>

                    </div>
                    <div class='col droptitle  pl-3 pr-3 ml-3 mt-0'>
                        <div class='row'>
                            <div class='col mt-1'>
                                <header>
                                    <H5>Data center costs</H5>
                                </header>
                            </div>
                        </div>
                        <div id="Data" *ngIf="toggleOptions.Data">
                            <div class="row mt-3">
                                <div class="col-lg-10 col-md-8 col-sm-8 col-9">
                                    <header>
                                        <H6>Hardware configuration</H6>
                                    </header>
                                </div>
                                <div class="col-lg-2 col-md-4 col-sm-2 col-3">
                                    <header>
                                        <H6>Rack units required</H6>
                                    </header>
                                </div>
                            </div>

                            <div class="row" *ngFor="let item of dataCentCostAssumption">
                                <div class="col-lg-10 col-md-8 col-sm-8 col-9">
                                    <header>
                                        <p>{{item.Procs}} Proc, {{item.Cores}} Core/Proc, {{item.Size}} GB RAM</p>
                                    </header>
                                </div>
                                <div class='input-field _input-field col-lg-2 col-md-8 col-sm-4 col-3' style="text-align: right;">
                                    <input type='number' id='servers' name='servers' value='1' min='1' max='20000'[(ngModel)]="item.Size">
                                    <!-- <p>USD</p> -->
                                </div>
                            </div>
                            <div class="row mt-0" *ngIf="false">
                                <div class="col-lg-10 col-md-8 col-sm-8 col-9">
                                    <header>
                                        <p>Initial setup cost for a Data center</p>
                                    </header>
                                </div>
                                <div class='input-field _input-field col-lg-2 col-md-4 col-sm-4 col-3' style="text-align: right;">
                                    <input type='number' id='servers' name='servers' value='1' min='1' max='20000'>
                                    <!-- <p>USD</p> -->
                                </div>
                            </div>
                            <div class="row mt-0" *ngIf="false">
                                <div class="col-lg-10 col-md-8 col-sm-8 col-9">
                                    <header>
                                        <p>Data center construction cost per rack</p>
                                    </header>
                                </div>
                                <div class='input-field _input-field col-lg-2 col-md-4 col-sm-4 col-3' style="text-align: right;">
                                    <input type='number' id='servers' name='servers' value='1' min='1' max='20000' [(ngModel)]="data.ConstructionCost">
                                    <!-- <p>USD</p> -->
                                </div>
                            </div>
                            <div class="row mt-0" *ngIf="false">
                                <div class="col-lg-10 col-md-8 col-sm-8 col-9">
                                    <header>
                                        <p>Data center useful life</p>
                                    </header>
                                </div>
                                <div class='input-field _input-field col-lg-2 col-md-4 col-sm-4 col-2' style="text-align: right;">
                                    <input type='number' id='servers' name='servers' value='1' min='1' max='20000' [(ngModel)]="data.DataCenterUsefulLife">
                                    <!-- <p>USD</p> -->
                                </div>
                            </div>
                            <div class="row mt-0" *ngIf="false">
                                <div class="col-lg-10 col-md-8 col-sm-8 col-9">
                                    <header>
                                        <p>Rack units per rack </p>
                                    </header>
                                </div>
                                <div class='input-field _input-field col-lg-2 col-md-4 col-sm-4 col-3' style="text-align: right;">
                                    <input type='number' id='servers' name='servers' value='1' min='1' max='20000' [(ngModel)]="data.NumberOfRackUnitsPerRack">
                                    <!-- <p>USD</p> -->
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div id='"+formId+"' class='mt-2'>
                <div class='row'>
                    <div style='float: left;  text-align: center;' id='"divf1"' >

                        <div class='circle' (click)='onSTOToggleClick("Networking")'>
                            <img src='../../assets/images/arrow_down.svg' width='14px' height='14px'
                                id='Server"+index+"'/>
                        </div>

                    </div>
                    <div class='col droptitle  pl-3 pr-3 ml-3 mt-0'>
                        <div class='row'>
                            <div class='col mt-1'>
                                <header>
                                    <H5>Networking costs</H5>
                                </header>
                            </div>
                        </div>
                        <div id="Networking" *ngIf="toggleOptions.Networking">
                            <div class="row" *ngFor="let item of networkingAssumption">
                                <div class="col-lg-10 col-md-8 col-sm-12 col-12">
                                    <header>
                                        <p>{{item.Description}}</p>
                                    </header>
                                </div>
                                <div class='input-field _input-field col-lg-2 col-md-4 col-sm-12 col-12' style="text-align: right;">
                                    <input type='number' id='servers' name='servers' value='15%' min='1' max='100' [(ngModel)]="item.Value">
                                    <!-- <p>USD</p> -->
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div id='"+formId+"' class='mt-2'>
                <div class='row'>
                    <div style='float: left; text-align: center;' id='"divf1"'>

                        <div class='circle' (click)='onSTOToggleClick("Database")'>
                            <img src='../../assets/images/arrow_down.svg' width='14px' height='14px'
                                id='Server"+index+"'/>
                        </div>

                    </div>
                    <div class='col droptitle  pl-3 pr-3 ml-3 mt-0'>
                        <div class='row'>
                            <div class='col mt-1'>
                                <header>
                                    <H5>Database costs More info</H5>
                                </header>
                            </div>
                        </div>
                        <div id="Database" *ngIf="toggleOptions.Database">
                            <div class="row" *ngFor="let item of dbLicenseAssumption">
                                <div class="col-md-10">
                                    <header>
                                        <p>{{item.Description}}</p>
                                    </header>
                                </div>
                                <div class='input-field _input-field col-lg-2 col-sm-12 col-12' style="text-align: right;">
                                    <input type='number' id='servers' name='servers' value='14256%' min='1'
                                        max='120000' [(ngModel)]="item.Value">
                                    <!-- <p>USD</p> -->
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div id='"+formId+"' class='mt-2'>
                <div class='row'>
                    <div style='float: left; text-align: center;' id='"divf1"'>
                        <div class='circle' (click)='onSTOToggleClick("warehouse")'>
                            <img src='../../assets/images/arrow_down.svg' width='14px' height='14px'
                                id='Server"+index+"'/>
                        </div>
                    </div>
                    <div class='col droptitle pl-3 pr-3 ml-3 mt-0'>
                        <div class='row'>
                            <div class='col mt-1'>
                                <header>
                                    <H5>Data warehouse costs</H5>
                                </header>
                            </div>
                        </div>
                        <div id="warehouse" *ngIf="toggleOptions.warehouse">
                            <div class="row" *ngFor="let item of dataWareHouseAssumption">
                                <div class="col-lg-10 col-md-8 col-sm-12 col-12">
                                    <header>
                                        <p>{{item.Description}}</p>
                                    </header>
                                </div>
                                <div class='input-field _input-field col-lg-2 col-md-4 col-sm-12 col-12' style="text-align: right;">
                                    <input type='number' [attr.id]='item.ID' name='servers' value='121.25' min='1' max='20000' [(ngModel)]="item.Value">
                                    <!-- <p>USD</p> -->
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>





           




        </div>
    </div>
</section>
<section>
    <div class="row justify-content-center mt-3">
        <ul class="actions mr-2">
            <li><a (click)="back()" class="button alt" style="padding-left: 60px; padding-right: 60px;">Back</a></li>
        </ul>
        <ul class="actions ml-2">
            <li><a (click)="next()" class="button special">Next</a></li>
        </ul>
    </div>
</section>
<section>
    <div class="Orange blog c-flex" style=" text-align: center;">

        <h3 style="color: #fff;">Help us improve. Is the TCO calculator helpful?</h3>
        <div class="mt-4">
            <span class="actions m-2">
                <a class="button alt white">Next</a>
            </span>
            <span class="actions m-2">
                <a class="button alt white">No</a>
            </span>
        </div>

    </div>
</section>
